<mat-card>
  <app-card-header
    [title]="'Configuración real vs. deseada'"
    icono="rule"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-detalles-perfiles
      [configDeseada]="configDeseada"
      [luminaria]="luminaria"
    ></app-detalles-perfiles>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
